import { IShipmentData } from 'types/orders';

export interface ITransitToWarehouseTrackingInitialValues {
  estimatedEntryDate: string | undefined;
  trackingNumber: string;
  trackingLink: string;
}

/**
 * Obtiene fecha estimada, guía y link de tránsito a bodega desde `warehouseTemporaryStorage` o `trackingInfo`.
 */
export const getTransitToWarehouseTrackingInitialValues = (
  shipment: IShipmentData
): ITransitToWarehouseTrackingInitialValues => {
  const wts = shipment.warehouseTemporaryStorage;
  if (wts) {
    return {
      estimatedEntryDate: wts.estimatedEntryDate?.trim() || undefined,
      trackingNumber: wts.trackingCode?.trim() ?? '',
      trackingLink: wts.trackingUrl?.trim() ?? ''
    };
  }

  const ti = shipment.trackingInfo;
  if (!ti) {
    return { estimatedEntryDate: undefined, trackingNumber: '', trackingLink: '' };
  }

  const dateRaw = ti.currentEstimatedDeliverDate ?? ti.estimatedDeliveryDate;
  const estimatedEntryDate =
    dateRaw != null && String(dateRaw).trim() !== '' ? String(dateRaw).trim() : undefined;

  const trackingNumber =
    ti.trackerNumber != null && String(ti.trackerNumber).trim() !== ''
      ? String(ti.trackerNumber).trim()
      : '';

  const trackingLink = ti.trackingLink != null ? String(ti.trackingLink).trim() : '';

  return {
    estimatedEntryDate,
    trackingNumber,
    trackingLink
  };
};

/**
 * Cuenta productos seleccionados en la lista que arma el ProductSelector (checks de serial).
 */
export const getSelectedProductsCount = (shipments: IShipmentData[]): number =>
  shipments.reduce((count, shipment) => count + (shipment.products?.length ?? 0), 0);
